import * as d from 'utils/distanceTypes';

/**
 * makeOption
 * Creates a dropdown option for a distance type.
 *
 * ```
 * makeOption(value, text, description)
 * ```
 * @param { String } value: The value of the combinator.
 * @param { String } text: The display text.
 * @returns { Object } The dropdown option for the combinator.
 */
export const makeOption = (value, text) => ({
  value,
  text,
  subText: value,
});

export const distanceOptionsSingular = [
  makeOption(d.MILE, 'Mile'),
  makeOption(d.KILOMETER, 'Kilometer'),
];

export const distanceOptionsPlural = [
  makeOption(d.MILE, 'Miles'),
  makeOption(d.KILOMETER, 'Kilometers'),
];
